import React, { useEffect } from 'react'
import System from "../../../../../helper/system";
import Order from "@system/config/order";
import useReduxState from 'src/hooks/useReduxState';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __set, __remove } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import { useOrderStore } from 'src/hooks/order';

let c = System.getParams();

const OrderDetailListingHeader = () => {
    const { translation: t } = System;

    const { OrderDetailTabList, orderStatus: { Shipped, OrderReceived, OrderInProcess, Cancelled } } = Constants
    const [isReorderable, setIsReOrderable] = useReduxState(false, 'setIsReOrderable')
    const [{ }, { fetch_cart_data, check_item_exists_in_cart }, { add_cart_in_Bulk }] = useCartStore();
    const [{ selected_fields }, { }, { remove_all_selected_fields }] = useOrderStore();
    const [__check] = useAxiosIndicatorCheck();

    const onReOrderablePart = async () => {
        let url = Order.getOrderDetailTabsListRouteURL({
            tab: System.getParams().tab || OrderDetailTabList.BY_SHIPMENT.param_value,
            orderFilter: 'reorder'
        });
        history.pushState('', '', url);
        await setIsReOrderable(true)
        await remove_all_selected_fields()
    }

    const onAlllink = async () => {
        let url = Order.getOrderDetailTabsListRouteURL({
            tab: System.getParams().tab || OrderDetailTabList.BY_SHIPMENT.param_value,
            orderFilter: 'all'
        });
        history.pushState('', '', url);
        await setIsReOrderable(false)
        await remove_all_selected_fields()
    }

    useEffect(() => {
        if (c.orderFilter && c.orderFilter.toLowerCase() === 'reorder') {
            setIsReOrderable(true)
        }
    }, []);

    const AddToCart = async () => {
        let cartData = Object.values(selected_fields)
        let cart = []

        let checkItemParam = []
        let checkExistingItemResponse = false

        cartData.filter(obj => {
            let items = {}
            if (obj?.customerPartNumber !== null) {
                items = { itemNumber: obj?.itemNumber, cpn: obj?.customerPartNumber }
                checkItemParam.push(items)
            }
        })

        if (checkItemParam?.length > 0) {
            __set('CART_API_CALL');
            checkExistingItemResponse = await check_item_exists_in_cart({ items: checkItemParam })
        }

        if (checkExistingItemResponse === true) {
            let productParam = []
            cartData.map(async (v) => {
                productParam.push({
                    "quantity": Number(v?.mainQuantity),
                    "currency": System.getRegionCurrency(),
                    "backOrderedQuantity": 0,
                    "cpn": v.customerPartNumber,
                    "VendorCode": v.vendorCode,
                    "SAPMatGroup": v.sapMatGroup,
                    "partNumber": v.erpPartNumber,
                    "ItemNumber": v.itemNumber,
                    "ManufacturerPartNumber": v.manufacturPartNumber,
                    "ManufacturerCode": v.manufacturerCode,
                    "ManufacturerName": v.manufacturer,
                    "AssetURL": v.assetURL,
                    "type": "Shopping",
                    "ERPMFRPartNumber": v.erpmfrPartNumber,
                    "ERPManufacturerName": v.erpManufacturerName,
                    "ERPManufacturerCode": v.erpManufacturerCode,
                    "ShortDescription": v?.shortDescription || '',
                    isSoftwareDownloadable: v?.softwareFlag === 'Yes' || v?.softwareFlag === true || v?.softwareFlag === 'Y' ? true : false,
                    "seoItemNumber": v?.seoItemNumber
                })
            })

            System.popup('BomToCartItemReplacePopup', {
                cartReplaceItem: { "cartItems": productParam }, isFrom: Constants.systemModules.ORDER
            })
        } else {
            cartData.map(async (v) => {
                const newObj = {
                    partNumber: v.erpPartNumber,
                    ItemNumber: v.itemNumber,
                    ManufacturerPartNumber: v.manufacturPartNumber,
                    ERPMFRPartNumber: v.erpmfrPartNumber,
                    manufacturerCode: v.manufacturerCode,
                    quantity: Number(v?.mainQuantity),
                    backOrderedQuantity: 0,
                    manufacturerName: v.manufacturer,
                    cpn: v.customerPartNumber,
                    currency: System.getRegionCurrency(),
                    AssetURL: v.assetURL,
                    erpManufacturerName: v.erpManufacturerName,
                    erpManufacturerCode: v.erpManufacturerCode,
                    type: "Shopping",
                    ShortDescription: v?.shortDescription || '',
                    isSoftwareDownloadable: v?.softwareFlag === 'Yes' || v?.softwareFlag === true || v?.softwareFlag === 'Y' ? true : false,
                    seoItemNumber: v?.seoItemNumber
                };

                cart.push(newObj)
            })

            let params = {
                currency: System.getRegionCurrency(),
                cartItems: cart
            };
            let selectedProductData = await add_cart_in_Bulk(params);

            __set('CART_API_CALL');
            await fetch_cart_data({ minicart: true })
            __remove('CART_API_CALL');

            System.popup('AddedToCartBomPopup', { cartData: selectedProductData });
        }
    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between pt-0 flex-wrap flex-sm-nowrap">
                <div className="font-24 my-0 mb-3 mb-sm-0 font-bold">{t('orders')}</div>

                <div className="ms-sm-auto mb-0">
                    <div className="d-flex align-items-center font-12">
                        <b className='me-2'>{t('view')}: </b>
                        <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0 seprate-by-pipe font-12 lh-normal mt-0">
                            <li className="ms-2"
                                onClick={() => onAlllink()}><a href={void (0)}
                                    className={isReorderable === true ? 'text-blue2' : 'text-black cursor-default'}> {t('all')} </a></li>
                            <li className="ms-2"
                                onClick={() => onReOrderablePart()}><a href={void (0)}
                                    className={isReorderable === true ? 'text-black cursor-default' : 'text-blue2'}> {t('reorderableParts')}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="pcn-line-divider" />
            <div className='tab-right-area'>
                {
                    isReorderable === true &&
                    <button
                        className={`bs5 btn btn-primary w170 mb-3 mb-md-0 ${__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status && 'disabled'}`}
                        disabled={selected_fields && Object.entries(selected_fields).length > 0 ? false : true}
                        onClick={(e) => {
                            __check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? e.preventDefault() : AddToCart()
                        }}
                    >
                        {__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ?
                            <i className="fa fa-spinner fa-spin" /> :
                            <span>{t('addToCart')} <i className="fa fa-cart-plus ms-1" /></span>}
                    </button>
                }
            </div>
        </>
    )
}

export default OrderDetailListingHeader